<footer class="footer">
  <div class="wrap footer-row">
    @if (tenantScope.tenant(); as tenant) {
      <a class="footer-logo" [routerLink]="['/retailer', tenant.slug]">
        <b>{{ tenant.theme.logoPrimaryText }}</b>
        <span>{{ tenant.theme.logoSecondaryText }}</span>
      </a>
      <nav class="footer-links" aria-label="Footer">
        <a class="footer-link" [routerLink]="['/retailer', tenant.slug]" fragment="stores">Our stores</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/orders/lookup">Order Lookup</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/help">Help</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/privacy">Privacy</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/terms">Terms</a>
      </nav>
      <p class="footer-legal">
        © 2026 {{ tenant.name }} · Powered by
        <span class="two-tone">
          <b>brijj</b>
          <span>works</span>
        </span>
        ·
        @if (tenantScope.marketplaceHomeUrl(); as marketplaceUrl) {
          <!-- Tenant owns this origin: leaving it is a cross-origin trip. -->
          <a class="footer-link footer-link--back" [href]="marketplaceUrl">
            <app-icon name="chevron-left" [size]="12" />
            Back to Brijj Finds
          </a>
        } @else {
          <a class="footer-link footer-link--back" routerLink="/">
            <app-icon name="chevron-left" [size]="12" />
            Back to Brijj Finds
          </a>
        }
      </p>
    } @else {
      <a class="footer-logo" routerLink="/">
        <b>brijj</b>
        <span>finds</span>
      </a>
      <nav class="footer-links" aria-label="Footer">
        <a class="footer-link" routerLink="/sell" fragment="how">How it works</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/sell">Sell with Brijj</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/orders/lookup">Order Lookup</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/help">Help</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/privacy">Privacy</a>
        <span class="dot" aria-hidden="true">·</span>
        <a class="footer-link" routerLink="/terms">Terms</a>
      </nav>
      <p class="footer-legal">© 2026 Brijjworks · Payments processed by Brijj</p>
    }
  </div>
</footer>
